export const ApiUrlBuilder = {
  getSiteCacheKey: (orga: string, siteId: string) => `site-cache/${orga}/${siteId}`,
  getUser: () => "/api/user/me",
  getFloor: (orgaId: string, floorId: string) => `/api/organizations/${orgaId}/plans/floor/${floorId}`,
  getAnnotations: (orgaId: string,  siteId: string|null, buildingId: string|null, floorId: string|null) => {
    let url= `/api/organizations/${orgaId}/annotations`;
    if(siteId) {
      url += `?siteId=${siteId}`;
    }
    if(buildingId) {
      url +=  (siteId) ? `&buildingId=${buildingId}` :  `?buildingId=${buildingId}` ;
    }
    if(floorId) {
      url +=  (siteId || buildingId) ? `&floorId=${floorId}` :  `?floorId=${floorId}` ;
    }
    return url;
  },
  getAllAnnotations: (orgaId: string) => `/api/organizations/${orgaId}/annotations/all`,
  getAnnotationById: (orgaId: string, annotationId: string) => `/api/organizations/${orgaId}/annotations/${annotationId}`,
  createAnnotation: (orgaId: string) => `/api/organizations/${orgaId}/annotations`,
  deleteAnnotation: (orgaId: string) => `/api/organizations/${orgaId}/annotations/delete`,
  getAttributes: (orgaId: string, siteId:  string, buildingId:  string, floorId:  string, assetId:  string) => {
    let url= `/api/organizations/${orgaId}/attributes?siteId=${siteId}&buildingId=${buildingId}&floorId=${floorId}`;
    if(assetId) {
      url += `&assetId=${assetId}`;
    }
    return url;
  },

  updateAttribute: (orgaId: string, componentId: string, attributeId: string) =>
    `/api/organizations/${orgaId}/attributes/${componentId}/${attributeId}`,
  getBuilding: (orgaId: string, buildingId: string) => `/api/organizations/${orgaId}/buildings/${buildingId}`,
  getSites: (orgaId: string, page?: number, pageSize?: number) => {
    let url = `/api/organizations/${orgaId}/sites`;
    if (page !== undefined && pageSize !== undefined) {
      url += `/page/${page}/size/${pageSize}`;
    }
    return url;
  },
  getSite: (orgaId: string, siteId: string) => `/api/organizations/${orgaId}/sites/${siteId}`,
  getSitePhoto: (orgaId: string, siteId: string) => `/api/organizations/${orgaId}/sites/${siteId}/photo`,
  getOutdoorAreasPlan: (orgaId: string, siteId: string) => `/api/organizations/${orgaId}/plans/site/${siteId}`,
  getCharacteristics: (orgaId: string) => `/api/organizations/${orgaId}/meta-library/characteristics`,
  getAssetAncestors: (orgaId: string, assetId: string) => `/api/organizations/${orgaId}/plans/${assetId}/ancestors`,
  getMetaLibrary: (orgaId: string) => `/api/organizations/${orgaId}/meta-library/all`,
};

export const InternalUrlBuilder = {
  getOfflineCreatedAnnotations: (orgaId: string, siteId: string|null, buildingId: string|null, floorId: string|null) => {
    let url= `/api/organizations/${orgaId}/annotations/created-offline`;
    if(siteId) {
      url += `?siteId=${siteId}`;
    }
    if(buildingId) {
      url +=  (siteId) ? `&buildingId=${buildingId}` :  `?buildingId=${buildingId}` ;
    }
    if(floorId) {
      url +=  (siteId || buildingId) ? `&floorId=${floorId}` :  `?floorId=${floorId}` ;
    }
    return url;
  },
  getOfflineUpdatedExistingAnnotations: (orgaId: string, siteId: string, buildingId: string, floorId: string) =>
    `/api/organizations/${orgaId}/annotations/updated-offline?siteId=${siteId}&buildingId=${buildingId}&floorId=${floorId}`,
  getOfflineDeletedAnnotations: (orgaId: string, siteId: string, buildingId: string, floorId: string) =>
    `/api/organizations/${orgaId}/annotations/deleted-offline?siteId=${siteId}&buildingId=${buildingId}&floorId=${floorId}`,
  getOfflineUpdatedAttributes: (orgaId: string, siteId: string, buildingId: string, floorId: string) =>
    `/api/organizations/${orgaId}/attributes/updated-offline?siteId=${siteId}&buildingId=${buildingId}&floorId=${floorId}`,
};

export const ApiUrlMatcher = {
  getUser: /^.*\/api\/user\/me$/,
  siteCacheKey: /^site-cache\/(?<orga>[^/]+)\/(?<siteId>[^/]+)$/,
  deleteAnnotation: /^.*\/api\/organizations\/(?<orga>[^/]+)\/annotations\/delete$/,
  createAnnotation: /^.*\/api\/organizations\/(?<orga>[^/]+)\/annotations$/,
  updateAnnotation: /^.*\/api\/organizations\/(?<orga>[^/]+)\/annotations$/,
  getAllAnnotations: /^.*\/api\/organizations\/(?<orga>[^/]+)\/annotations\/all$/,
  getAnnotationById: /^.*\/api\/organizations\/(?<orga>[^/]+)\/annotations\/(?<annotationId>[a-zA-Z0-9_-]+)$/,
  getAnnotations:
    /^.*\/api\/organizations\/(?<orga>[^/]+)\/annotations\?siteId=(?<siteId>[^/]+)&buildingId=(?<buildingId>[^/]+)&floorId=(?<floorId>[^/]+)$/,
  getAreaAnnotations:
    /^.*\/api\/organizations\/(?<orga>[^/]+)\/annotations\?siteId=(?<siteId>[^/]+)$/,
    getSite: /^.*\/api\/organizations\/(?<orga>[^/]+)\/sites\/(?<siteId>[^/]+)$/,
  getSites: /^.*\/api\/organizations\/(?<orga>[^/]+)\/sites(\/page\/\d+\/size\/\d+)?$/,
  getAttributes:
    /^.*\/api\/organizations\/(?<orga>[^/]+)\/attributes\?siteId=(?<siteId>[^/]+)&buildingId=(?<buildingId>[^/]+)&floorId=(?<floorId>[^/]+)&assetId=(?<assetId>[^/]+)$/,
  updateAttribute: /^.*\/api\/organizations\/(?<orga>[^/]+)\/attributes\/(?<componentId>[^/]+)\/(?<attributeId>[^/]+)$/,
  getCharacteristics: /^.*\/api\/organizations\/(?<orga>[^/]+)\/meta-library\/characteristics$/,
  getMetaLibrary: /^.*\/api\/organizations\/(?<orga>[^/]+)\/meta-library\/all$/,
};
